import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class COWTUXProgressBarService {
    private _visibleSubject = new BehaviorSubject<boolean>(false);
    private _diameterSubject = new BehaviorSubject<number>(50); // Default diameter

    // Internal state for debounced show
    private _showTimeout: any = null;
    private _isVisible = false;
    // Default debounce delay (ms) before showing the loader to avoid flashing
    private readonly SHOW_DELAY_MS = 300;

    visible = this._visibleSubject.asObservable();
    diameter = this._diameterSubject.asObservable();

    // Show the progress bar after a short delay. If hide() is called before the delay
    // the bar will never be shown. This prevents quick background operations from
    // producing a flashing loader.
    show(immediate: boolean = false): void {
        // If already visible, nothing to do
        if (this._isVisible) {
            return;
        }

        // If caller requests immediate show, clear any pending timer and show now
        if (immediate) {
            if (this._showTimeout) {
                clearTimeout(this._showTimeout);
                this._showTimeout = null;
            }
            this._isVisible = true;
            this._visibleSubject.next(true);
            return;
        }

        // Debounced show
        if (this._showTimeout) {
            clearTimeout(this._showTimeout);
        }
        this._showTimeout = setTimeout(() => {
            this._showTimeout = null;
            this._isVisible = true;
            this._visibleSubject.next(true);
        }, this.SHOW_DELAY_MS);
    }

    // Hide immediately and cancel any pending delayed show
    hide(): void {
        if (this._showTimeout) {
            clearTimeout(this._showTimeout);
            this._showTimeout = null;
        }

        if (this._isVisible) {
            this._isVisible = false;
            this._visibleSubject.next(false);
        }
    }

    setDiameter(diameter: number): void {
        this._diameterSubject.next(diameter);
    }
}
